(function () {
  if (window.__v6count) return;
  window.__v6count = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Bottom edge of the theme's fixed header, so the stage fits the screen below it.
  // The header is only fixed in some scroll states; keep the CSS default until it can be measured.
  function headerOffset() {
    var h = 0;
    document.querySelectorAll('#header, .header').forEach(function (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.height > 0 && r.top <= 1) h = Math.max(h, r.bottom);
    });
    if (h > 0) document.documentElement.style.setProperty('--v6-head', Math.round(h) + 'px');
  }
  // B001 count-down: one screen that steps 60 → 3 → 0 → 1 → 3 by itself while it is on screen.
  // Nothing listens to scroll; the active index line runs as a CSS animation and its end advances the step.
  function init(root) {
    if (root.__v6) return;
    root.__v6 = true;
    var steps = root.querySelectorAll('[data-v6-step]'), tabs = root.querySelectorAll('[data-v6-go]'), toggle = root.querySelector('[data-v6-toggle]');
    var n = steps.length, active = 0, seen = false, inView = false, held = false, user = false, leave = 0;
    var auto = root.hasAttribute('data-v6-autoplay') && n > 1;
    if (!n) return;
    function go(i, dir) {
      if (i === active) return;
      var from = steps[active], to = steps[i];
      // The outgoing photo keeps its slow push-in while the next one fades in over it.
      clearTimeout(leave);
      steps.forEach(function (s) { s.classList.remove('is-leaving'); });
      from.classList.add('is-leaving');
      leave = setTimeout(function () { from.classList.remove('is-leaving'); }, 700);
      // Park the incoming numeral on the side it enters from without animating the jump.
      to.classList.add('is-quiet');
      to.classList.toggle('is-before', dir < 0);
      void to.offsetWidth;
      to.classList.remove('is-quiet', 'is-before');
      from.classList.remove('is-active');
      from.classList.toggle('is-before', dir > 0);
      to.classList.add('is-active');
      tabs[active].classList.remove('is-active');
      tabs[active].setAttribute('aria-pressed', 'false');
      tabs[i].classList.add('is-active');
      tabs[i].setAttribute('aria-pressed', 'true');
      active = i;
      root.setAttribute('data-v6-mode', to.getAttribute('data-v6-step'));
    }
    function sync() {
      var on = auto && !user && !reduce.matches;
      root.classList.toggle('is-auto', on);
      root.classList.toggle('is-playing', on && inView && !held && !document.hidden);
      if (toggle) {
        toggle.hidden = !auto || reduce.matches;
        toggle.textContent = on ? 'Pause' : 'Play';
      }
    }
    root.addEventListener('animationend', function (e) {
      if (e.animationName === 'v6-count-run' && root.classList.contains('is-playing')) go((active + 1) % n, 1);
    });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { user = true; go(i, i > active ? 1 : -1); sync(); });
    });
    if (toggle) toggle.addEventListener('click', function () { user = !user; sync(); });
    // Hold still while a mouse rests on it or keyboard focus is inside.
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { held = true; sync(); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { held = false; sync(); } });
    root.addEventListener('focusin', function (e) { held = e.target.matches(':focus-visible'); sync(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { held = false; sync(); } });
    if (!reduce.matches) root.classList.add('is-waiting');
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView && !seen) { seen = true; headerOffset(); root.classList.remove('is-waiting'); }
      sync();
    }, { threshold: 0.5 }).observe(root.querySelector('.v6-count__stage'));
    document.addEventListener('visibilitychange', sync);
    if (reduce.addEventListener) reduce.addEventListener('change', sync);
    root.setAttribute('data-v6-mode', steps[0].getAttribute('data-v6-step'));
    sync();
  }
  function scan(root) { root.querySelectorAll('[data-v6-count]').forEach(init); }
  headerOffset();
  window.addEventListener('resize', headerOffset);
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { headerOffset(); scan(e.target); });
})();
